import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { LotType } from './lotTypes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/lotTypes');

export const getLotTypes = actionCreator.async<{}, LotType[]>('GET_LOT_TYPES');
export const createLotType = actionCreator.async<{ data: Partial<LotType>; formName: FormName }, LotType>(
  'CREATE_LOT_TYPE',
);
export const updateLotType = actionCreator.async<{ data: Partial<LotType>; formName: FormName }, LotType>(
  'UPDATE_LOT_TYPE',
);
export const deleteLotType = actionCreator.async<{ id: string; formName: FormName }, string>('DELETE_LOT_TYPE');
